import { CarouselWithDefault } from "./CarouselWithDefault";

type EngagementCarouselParams = {
    examples: string[];
};
export function EngagementCarousel({ examples }: EngagementCarouselParams) {
    const checklistItemExamples = examples.map((text) => ({ text }));

    return <CarouselWithDefault examples={checklistItemExamples} />;
}
